module.exports = "pegasus/assets/blocks/column-lp4-themelp1.png";